import { z } from 'zod';

// Onboarding step schema
export const OnboardingStepSchema = z.object({
  step_id: z.string().min(1, "Step ID is required"),
  is_completed: z.boolean(),
  completed_at: z.string().datetime().optional(),
});

export type OnboardingStep = z.infer<typeof OnboardingStepSchema>;

// Onboarding progress schema
export const OnboardingProgressSchema = z.object({
  id: z.string().optional(),
  created_time: z.string().datetime().optional(),
  last_updated_time: z.string().datetime().optional(),
  user_id: z.string().min(1, "User ID is required").optional().nullable(),
  steps: z.array(OnboardingStepSchema),
  is_collapsed: z.boolean(),
  completed_count: z.number().int().min(0).optional(),
});

export type OnboardingProgress = z.infer<typeof OnboardingProgressSchema>;

// Collapse state update schema
export const CollapseStateUpdateSchema = z.object({
  is_collapsed: z.boolean(),
});

export type CollapseStateUpdate = z.infer<typeof CollapseStateUpdateSchema>;

// Onboarding step config schema (for UI configuration)
export const OnboardingStepConfigSchema = z.object({
  id: z.string().min(1, "Step ID is required"),
  title: z.string().min(1, "Title is required"),
  description: z.string().min(1, "Description is required"),
  // Note: icon is React.ReactNode which can't be validated with Zod at runtime
});

export type OnboardingStepConfig = z.infer<typeof OnboardingStepConfigSchema>;

// API Response wrapper
export const ApiResponseSchema = <T extends z.ZodType>(dataSchema: T) => z.object({
  status: z.enum(['OK', 'ERROR']),
  data: z.array(dataSchema).optional(),
  message: z.string().optional(),
  total: z.number().int().min(0).optional(),
  page: z.number().int().min(1).optional(),
  pageSize: z.number().int().min(1).optional(),
});

export type ApiResponse<T> = {
  status: 'OK' | 'ERROR';
  data?: T[];
  message?: string;
  total?: number;
  page?: number;
  pageSize?: number;
};
